import { Checkbox, type ICheckboxProps, SubText } from '@procurify/ui'
import { useIntl } from 'react-intl'

import messages from './messages'
import { TaxInclusiveCheckboxStyled } from './styles/TaxInclusiveCheckboxStyled'

export interface ITaxInclusiveCheckboxProps
  extends Omit<ICheckboxProps, 'onChange'> {
  onChange?: (checked?: boolean) => void
}

export const TaxInclusiveCheckbox = ({
  onChange = () => undefined,
  checked,
  ...checkBoxProps
}: ITaxInclusiveCheckboxProps) => {
  const intl = useIntl()

  return (
    <TaxInclusiveCheckboxStyled>
      <label>
        <SubText>{intl.formatMessage(messages.inclusiveLabel)}</SubText>
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          inputProps={{
            'aria-label': intl.formatMessage(messages.ariaLabel),
          }}
          {...checkBoxProps}
        />
      </label>
    </TaxInclusiveCheckboxStyled>
  )
}

TaxInclusiveCheckbox.displayName = 'TaxInclusiveCheckbox'
